"use strict";

/**
 * TileTeaser
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.TileTeaser = T.createModule({
  start: function start(resolve) {
    this.$ctx = $(this._ctx);
    resolve();
  }
});